//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import filterMixin from '@/mixins/filter';
import FiltersMobileModal from './filtersMobileModal.vue';
import viewportMixin from '@/mixins/viewport.mixin';
import CommonSelect from '@/components/ebac-ui-kit/commonSelect/commonSelect.vue';

export default {
  components: { FiltersMobileModal, CommonSelect },
  mixins: [filterMixin, viewportMixin],
  data() {
    return {
      selectedTypes: [],
      selectedDirections: [],
      selectDropdownElements: [],
      menuElements: [],
      currentScale: 1,
    };
  },
  computed: {
    search: {
      get() {
        return this.filter.search;
      },
      set(payload) {
        return this.filterFieldUpdate('search', payload);
      },
    },
    directions: {
      get() {
        return this.filter.directions;
      },
      set(payload) {
        return this.filterFieldUpdate('directions', payload);
      },
    },
    types: {
      get() {
        return this.filter.types;
      },
      set(payload) {
        return this.filterFieldUpdate('types', payload);
      },
    },
    status: {
      get() {
        return this.filter.status;
      },
      set(payload) {
        return this.filterFieldUpdate('status', payload);
      },
    },
    computedTypes() {
      return this.$store.getters['eventsList/GET_TYPES'](this);
    },
    mappedDirections() {
      const directions = this.$store.getters['eventsList/GET_DIRECTIONS'](this);
      return directions.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    },
    computedDirectionsPlaceholder() {
      if (this.selectedDirections.length === 0) {
        return this.$t('rt0822.events.filters.directions.placeholder');
      }
      return this.$tc(
        'rt0822.multiselect.directions.selected',
        this.selectedDirections.length,
        {
          count: this.selectedDirections.length,
        },
      );
    },
    computedTypesPlaceholder() {
      if (this.selectedTypes.length === 0) {
        return this.$t('rt0822.events.filters.types.placeholder');
      }
      return this.$tc(
        'rt0822.multiselect.types.selected',
        this.selectedTypes.length,
        {
          count: this.selectedTypes.length,
        },
      );
    },
  },
  watch: {
    'filter.directions': {
      handler(value) {
        this.$store.commit('eventsList/SET_SELECTED_DIRECTIONS_IDS', value);
        const selectedDirectionsIds =
          this.$store.getters['eventsList/GET_SELECTED_DIRECTIONS_IDS']();

        const selectedDirections = selectedDirectionsIds.map((id) =>
          this.$store.getters['eventsList/GET_DIRECTION_BY_ID'](id),
        );

        const mappedSelectedDirections = selectedDirections.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        this.selectedDirections = mappedSelectedDirections;
      },
    },
    'filter.types': {
      handler(value) {
        this.$store.commit('eventsList/SET_SELECTED_TYPE_VALUES', value);
        const selectedTypeValues =
          this.$store.getters['eventsList/GET_SELECTED_TYPE_VALUES']();

        const mappedSelectedTypes = selectedTypeValues.map((value) =>
          this.$store.getters['eventsList/GET_TYPE_BY_VALUE'](this)(value),
        );

        this.selectedTypes = mappedSelectedTypes;
      },
    },
  },
  created() {
    this.createFilter('eventList', [
      { name: 'search', clearable: true, urlQuery: true },
      {
        name: 'directions',
        array: true,
        clearable: true,
        urlParam: true,
        urlParamReplace: true,
        urlValueGetter: 'eventsList/GET_DIRECTION_SLUG_FROM_ID',
        serverValueGetter: 'eventsList/GET_DIRECTION_ID_FROM_SLUG',
      },
      { name: 'types', urlQuery: true, array: true, clearable: true },
      { name: 'status', urlQuery: true },
    ]);
  },
  methods: {
    toggleStatus() {
      this.$nextTick(() => {
        if (this.filter.status === 'finished') {
          this.status = '';
        } else {
          this.status = 'finished';
        }
      });
    },
    selectDirection(value) {
      const ids = value.map((item) => item.value);
      this.$store.commit('eventsList/SET_SELECTED_DIRECTIONS_IDS', ids);
      const selectedDirectionsIds =
        this.$store.getters['eventsList/GET_SELECTED_DIRECTIONS_IDS']();
      this.filterFieldUpdate('directions', selectedDirectionsIds);
    },
    selectType(value) {
      const values = value.map((item) => item.value);
      this.$store.commit('eventsList/SET_SELECTED_TYPE_VALUES', values);
      const selectedTypeValues =
        this.$store.getters['eventsList/GET_SELECTED_TYPE_VALUES']();
      this.filterFieldUpdate('types', selectedTypeValues);
    },
  },
};
